import DocumentLibrary from "../components/DocumentLibrary";

export default function Quotation() {
  return (
    <DocumentLibrary
      docType="quotation"
      title="Quotation"
      subtitle="Customer quotations"
      accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.csv"
      columns={["Quotation Number", "Quotation Date", "Customer", "File Name", "File Type"]}
      metaFields={[
        { key: "quotationNumber", label: "Quotation Number", required: true },
        { key: "quotationDate", label: "Quotation Date", type: "date", required: true },
        { key: "customerName", label: "Customer Name", required: true },
        { key: "customerAddress", label: "Customer Address", full: true },
        { key: "contactPerson", label: "Contact Person" },
        { key: "mobile", label: "Mobile" },
        { key: "email", label: "Email" },
      ]}
    />
  );
}
